import { render, staticRenderFns } from "./basic_primaryadd.vue?vue&type=template&id=a8a94d7e&scoped=true"
import script from "./basic_primaryadd.vue?vue&type=script&lang=js"
export * from "./basic_primaryadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a94d7e",
  null
  
)

export default component.exports